/* ===========================================================================
   THE CART DRAWER. One behaviour, four arms - the arm is decided in Liquid, not
   here, so nothing in this file branches on it except where a board genuinely
   differs (arm 3's countdown, arm 4's footer arrival line).

   IT ALSO OWNS ADD TO CART. With UpCart's app embed off, nothing intercepts the
   product form: theme.AjaxProduct is only wired by the `main-product` section,
   which is disabled in every product template, so a click did a NATIVE form POST
   and navigated the shopper to /cart. Measured on all five themes. This file
   intercepts that submit and posts /cart/add.js instead.

   ADDING DOES NOT OPEN THIS DRAWER. The added-to-cart popup is what a shopper
   sees after an add. The drawer opens from the header icon, and from the popup's
   View cart button - both deliberate clicks.

   TICKING PROTECTION DOES NOT POP THE POPUP EITHER, and that falls out for free:
   the popup skips any line carrying `__upcart*` properties, and protection is
   added with exactly those, because it must land in the order identically to the
   way UpCart added it. One guard, two jobs.

   EVERY MUTATION IS OPTIMISTIC-FREE: the cart is re-fetched and re-rendered from
   the server response, so what is on screen is always what Shopify holds. The
   busy state is a quiet overlay that does NOT change layout.
   =========================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('[data-ob-cart]');
  var cfgEl = document.getElementById('ob-cart-config');
  if (!root || !cfgEl || root.dataset.obCartBound === '1') { return; }
  root.dataset.obCartBound = '1';

  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  var $ = function (s) { return root.querySelector(s); };
  var panel = $('[data-ob-cart-panel]');
  var scrim = $('[data-ob-cart-scrim]');
  var elCount = $('[data-ob-cart-count]');
  var elArrive = $('[data-ob-cart-arrive]');
  var elArriveFoot = $('[data-ob-cart-arrive-foot]');
  var elCutoff = $('[data-ob-cart-cutoff]');
  var elCutoffText = $('[data-ob-cart-cutoff-text]');
  var elItems = $('[data-ob-cart-items]');
  var elEmpty = $('[data-ob-cart-empty]');
  var elProt = $('[data-ob-cart-prot]');
  var elProtInput = $('[data-ob-cart-prot-input]');
  var elProtPrice = $('[data-ob-cart-prot-price]');
  var elSubtotal = $('[data-ob-cart-subtotal]');
  var elDiscRow = $('[data-ob-cart-discount-row]');
  var elDiscLabel = $('[data-ob-cart-discount-label]');
  var elDiscValue = $('[data-ob-cart-discount-value]');
  var elTotal = $('[data-ob-cart-total]');
  var elFoot = $('[data-ob-cart-foot]');
  var elBusy = $('[data-ob-cart-busy]');

  var lastOpener = null;
  var busyDepth = 0;
  var cart = null;

  /* ------------------------------------------------------------------ money
     From the CART, never hardcoded. The shop's own format wins in the base
     currency because Intl in a non-US locale renders USD as "US$54.99" where the
     store writes "$54.99"; Intl is used only when the shopper is genuinely served
     another currency, where the right symbol matters more than the house format. */
  function money(cents, currency) {
    var cur = currency || (cart && cart.currency) || CFG.shopCurrency;
    var amount = (Math.round(cents) / 100).toFixed(2);
    if (!cur || cur === CFG.shopCurrency) {
      return String(CFG.moneyFormat || '${{amount}}')
        .replace(/\{\{\s*amount[^}]*\}\}/, amount).replace(/<[^>]*>/g, '');
    }
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur })
        .format(cents / 100);
    } catch (e) {
      return String(CFG.moneyFormat || '${{amount}}')
        .replace(/\{\{\s*amount[^}]*\}\}/, amount).replace(/<[^>]*>/g, '');
    }
  }

  /* "Cart · 1 item" / "Cart · 2 items" - the board's exact format, middot with a
     space either side, and the singular is not optional. */
  function countText(n) {
    return 'Cart · ' + n + (n === 1 ? ' item' : ' items');
  }

  function isProtection(item) {
    var p = item.properties || {};
    for (var k in p) {
      if (Object.prototype.hasOwnProperty.call(p, k) && k.indexOf('__upcart') === 0) {
        return true;
      }
    }
    return item.handle === CFG.protection.handle;
  }

  /* ------------------------------------------------- compare-at prices
     /cart.js DOES NOT CARRY compare_at_price - measured: on a line whose product has a
     69.99 compare-at against a 54.99 price, every price field reads 5499 and the key is
     absent. So it is read from the product endpoint and cached per variant.

     PREFETCHED BEFORE RENDER, never filled in afterwards, so the strikethrough is in the
     first paint and the row cannot shift under the shopper. */
  var compareAt = {};          /* variantId -> cents, or 0 when there is none */

  function loadCompareAt(items) {
    var want = items.filter(function (i) {
      return i.handle && compareAt[i.variant_id] === undefined;
    });
    if (!want.length) { return Promise.resolve(); }
    return Promise.all(want.map(function (i) {
      return fetch('/products/' + i.handle + '.js',
                   { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          var c = 0;
          if (p && p.variants) {
            for (var k = 0; k < p.variants.length; k++) {
              if (p.variants[k].id === i.variant_id) {
                c = p.variants[k].compare_at_price || 0;
                break;
              }
            }
          }
          compareAt[i.variant_id] = c;
        })
        .catch(function () { compareAt[i.variant_id] = 0; });
    }));
  }

  /* ------------------------------------------------------------- the network */
  function busy(on) {
    busyDepth += on ? 1 : -1;
    if (busyDepth < 0) { busyDepth = 0; }
    var active = busyDepth > 0;
    elBusy.hidden = !active;
    panel.setAttribute('aria-busy', active ? 'true' : 'false');
  }

  function api(url, body) {
    busy(true);
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); })
      .then(function (d) { busy(false); return d; })
      .catch(function (e) { busy(false); throw e; });
  }

  function refresh() {
    busy(true);
    return getCart()
      .then(reconcile)
      .then(function (c) {
        cart = c;
        return loadCompareAt(c.items).then(function () {
          busy(false); render(); return c;
        });
      })
      .catch(function () { busy(false); });
  }

  /* --------------------------------------------------------------- rendering */
  function itemNode(item) {
    var li = document.createElement('li');
    li.className = 'ob-cart__item';
    li.setAttribute('data-key', item.key);

    var img = document.createElement('img');
    img.className = 'ob-cart__thumb';
    img.width = 64; img.height = 82; img.loading = 'lazy'; img.alt = '';
    var src = item.image || (item.featured_image && item.featured_image.url) || '';
    if (src) {
      img.src = src.indexOf('cdn.shopify.com') > -1
        ? src.replace(/(\.(?:png|jpe?g|webp|gif))(\?|$)/i, '_128x164_crop_center$1$2')
        : src;
    }
    li.appendChild(img);

    var col = document.createElement('div');
    col.className = 'ob-cart__item-col';

    var top = document.createElement('div');
    top.className = 'ob-cart__item-top';
    var title = document.createElement('span');
    title.className = 'ob-cart__item-title';
    title.textContent = item.product_title || item.title || '';
    var price = document.createElement('span');
    price.className = 'ob-cart__item-price';
    price.textContent = money(item.final_line_price);
    /* COMPARE-AT ONLY WHERE IT IS GENUINELY HIGHER, so a stale compare-at never fakes
       a saving. It comes from the product endpoint - see loadCompareAt - because
       /cart.js does not carry it. Multiplied by the quantity so it lines up with the
       LINE price beside it, not the unit price. */
    var ca = compareAt[item.variant_id] || 0;
    if (ca && ca * item.quantity > item.final_line_price) {
      var was = document.createElement('s');
      was.className = 'ob-cart__item-was';
      was.textContent = money(ca * item.quantity);
      price.insertBefore(was, price.firstChild);
      price.insertBefore(document.createTextNode(' '), price.lastChild);
    }
    top.appendChild(title);
    top.appendChild(price);
    col.appendChild(top);

    /* "Colour · Size". The cart boards draw Size first; the brief and the shipped
       added-to-cart popup both put Colour first, and the two surfaces must agree. */
    var opts = item.options_with_values || [];
    var parts = [];
    for (var i = 0; i < opts.length; i++) {
      var v = String(opts[i].value || '');
      if (!v || v === 'Default Title') { continue; }
      parts.push(/size/i.test(String(opts[i].name || '')) ? ('Size ' + v) : v);
    }
    if (parts.length) {
      var variant = document.createElement('span');
      variant.className = 'ob-cart__item-variant';
      variant.textContent = parts.join(' · ');
      col.appendChild(variant);
    }

    var bottom = document.createElement('div');
    bottom.className = 'ob-cart__item-bottom';

    /* THE STEPPER IS AN ADDITION. The boards draw no quantity control at all, which
       would leave remove-and-re-add as the only way to change a quantity. Square,
       hairline, house button style. */
    var step = document.createElement('span');
    step.className = 'ob-cart__qty';
    var minus = document.createElement('button');
    minus.type = 'button';
    minus.className = 'ob-cart__qty-btn';
    minus.setAttribute('data-ob-qty', '-1');
    minus.setAttribute('aria-label', 'Decrease quantity');
    minus.textContent = '−';
    var num = document.createElement('span');
    num.className = 'ob-cart__qty-num';
    num.setAttribute('aria-live', 'polite');
    num.textContent = item.quantity;
    var plus = document.createElement('button');
    plus.type = 'button';
    plus.className = 'ob-cart__qty-btn';
    plus.setAttribute('data-ob-qty', '1');
    plus.setAttribute('aria-label', 'Increase quantity');
    plus.textContent = '+';
    step.appendChild(minus); step.appendChild(num); step.appendChild(plus);
    bottom.appendChild(step);

    var rm = document.createElement('button');
    rm.type = 'button';
    rm.className = 'ob-cart__remove';
    rm.setAttribute('data-ob-remove', '1');
    rm.textContent = 'Remove';
    bottom.appendChild(rm);

    col.appendChild(bottom);
    li.appendChild(col);
    return li;
  }

  function render() {
    if (!cart) { return; }
    var lines = cart.items.filter(function (i) { return !isProtection(i); });
    var prot = cart.items.filter(isProtection)[0] || null;

    elCount.textContent = countText(lines.reduce(function (a, i) { return a + i.quantity; }, 0));

    elItems.textContent = '';
    lines.forEach(function (i) { elItems.appendChild(itemNode(i)); });

    var empty = lines.length === 0;
    elEmpty.hidden = !empty;
    elItems.hidden = empty;
    /* WITH AN EMPTY CART there is nothing to protect and nothing to total, so the
       protection row and the whole footer go rather than showing a $0.00 Checkout. */
    elProt.hidden = empty;
    elFoot.hidden = empty;

    if (!empty) {
      elProtInput.checked = !!prot;
      elProtPrice.textContent = '  ' + money(protPrice(prot));

      elSubtotal.textContent = money(cart.items_subtotal_price);
      var disc = cart.cart_level_discount_applications || [];
      if (disc.length && cart.total_discount > 0) {
        elDiscRow.hidden = false;
        elDiscLabel.textContent = disc[0].title || 'Discount';
        elDiscValue.textContent = '-' + money(cart.total_discount);
      } else {
        elDiscRow.hidden = true;
      }
      elTotal.textContent = money(cart.total_price);
    }
    paintDates();
  }

  /* The price the row advertises is the REAL one: the line if it is in the cart,
     otherwise whatever the config says the variant costs. Never the board's $3.00. */
  var protCents = null;
  function protPrice(protLine) {
    if (protLine) { protCents = protLine.price; }
    return protCents === null ? 399 : protCents;
  }

  /* ------------------------------------------ protection, TICKED BY DEFAULT
     ARCHIE'S INSTRUCTION, 23 Sep 2026. Shared behaviour on all four arms, not an arm
     lever. Every rule is enforced in reconcile(), which runs on every cart read the
     drawer and the /cart page make, and always decides from the cart Shopify returns:
       - a cart with a real product and no protection gets ONE protection line, at the
         variant's own price, unless the shopper has unticked it this session;
       - unticking removes it at once and is remembered for the rest of the browser
         session (a session cookie, mirrored in sessionStorage), so no later add,
         quantity change or page load puts it back. Ticking it again clears that;
       - it is never the only thing in the cart: with no real product left it comes out;
       - it is never added twice: one reconcile runs at a time, a second caller waits
         and then re-reads the cart;
       - a failed add is SILENT - no error line, no popup, and the header count never
         includes protection - and it is not retried on this page. It only ever runs
         after the real product's add has succeeded, so it cannot block that add.
     UpCart stays off; nothing here uses upcartShouldSkipAddToCart. */
  var DECLINED = 'ob_prot_declined';

  function isDeclined() {
    try { if (window.sessionStorage.getItem(DECLINED) === '1') { return true; } } catch (e) {}
    return document.cookie.split('; ').indexOf(DECLINED + '=1') > -1;
  }

  function setDeclined(on) {
    try {
      if (on) { window.sessionStorage.setItem(DECLINED, '1'); }
      else { window.sessionStorage.removeItem(DECLINED); }
    } catch (e) {}
    document.cookie = DECLINED + (on ? '=1' : '=; max-age=0') + '; path=/; SameSite=Lax';
  }

  function getCart() {
    return fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); });
  }

  /* No busy overlay and no error surface: this is housekeeping, not a shopper action. */
  function quietPost(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) { throw new Error('protection ' + r.status); }
      return r.json();
    });
  }

  var protAddFailed = false;
  var reconciling = null;

  function reconcile(c) {
    if (reconciling) {
      return reconciling.then(function () { return getCart().then(reconcile); });
    }
    if (!c || !c.items) { return Promise.resolve(c); }
    var real = c.items.filter(function (i) { return !isProtection(i); });
    var prot = c.items.filter(isProtection);
    var work = null;

    if (!real.length && prot.length) {
      /* NEVER THE ONLY THING IN THE CART. Not a decline: the next real add ticks it again. */
      work = prot.reduce(function (p, line) {
        return p.then(function () { return quietPost('/cart/change.js', { id: line.key, quantity: 0 }); });
      }, Promise.resolve());
    } else if (real.length && !prot.length && !protAddFailed && !isDeclined()) {
      work = quietPost('/cart/add.js', {
        items: [{ id: CFG.protection.variantId, quantity: 1, properties: CFG.protection.properties }]
      }).catch(function () { protAddFailed = true; });
    } else if (prot.length > 1 || (prot.length && prot[0].quantity > 1)) {
      /* NEVER TWICE: one line, quantity one. */
      work = prot.reduce(function (p, line, n) {
        return p.then(function () {
          return quietPost('/cart/change.js', { id: line.key, quantity: n === 0 ? 1 : 0 });
        });
      }, Promise.resolve());
    }

    if (!work) { return Promise.resolve(c); }
    reconciling = work.then(getCart, getCart).then(
      function (c2) { reconciling = null; return c2; },
      function () { reconciling = null; return c; });
    return reconciling;
  }

  /* ------------------------------------------------ dates, from the ONE source */
  function paintDates() {
    if (!window.OB || !OB.deliveryRange) { return; }
    var range = OB.deliveryRange(CFG.deliveryMin, CFG.deliveryMax);
    if (elArrive && range) { elArrive.textContent = 'Arrives ' + range; }
    if (elArriveFoot && range) { elArriveFoot.textContent = 'Arrives ' + range; }

    if (!elCutoff || !elCutoffText) { return; }
    /* WHICH CUT OFF comes from OB.cutoffState (ob-dates.js), the rule the bar and the
       PDP read too. 'today' keeps the countdown exactly as before; after the hour and at
       the weekend the line names tomorrow's or Monday's cut off with no countdown. No
       reliable clock: hidden, taking no space. */
    var st = OB.cutoffState ? OB.cutoffState(CFG.cutoffHour) : null;
    var line = null;
    if (st && st.when === 'today') {
      var text = OB.formatRemaining(st.minutesLeft);
      if (text) {
        line = "Order within " + text + " to make today's " + CFG.cutoffLabel + ' cut off';
      }
    } else if (st) {
      line = OB.cutoffLine(st);
    }
    if (!line) { elCutoff.hidden = true; return; }
    elCutoffText.textContent = line;
    elCutoff.hidden = false;
  }
  setInterval(paintDates, 30000);

  /* ------------------------------------------------------------ open / close */
  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),[tabindex]:not([tabindex="-1"])';

  function open(opener) {
    /* 8 Oct 2026, the drawer always closes the "Added to cart" pop-up so it never covers the total and Checkout. */
    if (typeof window.__obAtcHide === 'function') { try { window.__obAtcHide(); } catch (e) {} }
    if (!root.hidden) { return; }
    lastOpener = opener || document.activeElement;
    root.hidden = false;
    document.documentElement.classList.add('ob-cart-open');
    /* SCROLL LOCK without a layout shift: the page keeps its scrollbar gutter. */
    var sw = window.innerWidth - document.documentElement.clientWidth;
    if (sw > 0) { document.documentElement.style.setProperty('--ob-sbw', sw + 'px'); }
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { root.setAttribute('data-open', '1'); });
    });
    refresh().then(function () {
      var f = panel.querySelector(FOCUSABLE);
      if (f) { f.focus(); }
    });
    document.addEventListener('keydown', onKey, true);
  }

  function close() {
    if (root.hidden) { return; }
    root.removeAttribute('data-open');
    document.removeEventListener('keydown', onKey, true);
    setTimeout(function () {
      root.hidden = true;
      document.documentElement.classList.remove('ob-cart-open');
      document.documentElement.style.removeProperty('--ob-sbw');
      /* FOCUS RETURNS to whatever opened it. */
      if (lastOpener && document.contains(lastOpener)) {
        try { lastOpener.focus(); } catch (e) {}
      }
      lastOpener = null;
    }, 180);
  }

  function onKey(e) {
    if (e.key === 'Escape' || e.keyCode === 27) { e.preventDefault(); close(); return; }
    if (e.key !== 'Tab') { return; }
    /* FOCUS TRAP. It is a task, so focus stays inside until it is dismissed. */
    var f = Array.prototype.filter.call(panel.querySelectorAll(FOCUSABLE), function (el) {
      return el.offsetParent !== null || el === document.activeElement;
    });
    if (!f.length) { return; }
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  scrim.addEventListener('click', close);
  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-ob-cart-close]')) { e.preventDefault(); close(); }
  });

  /* ------------------------------------------------------------- mutations */
  root.addEventListener('click', function (e) {
    var q = e.target.closest('[data-ob-qty]');
    var rm = e.target.closest('[data-ob-remove]');
    if (!q && !rm) { return; }
    var li = e.target.closest('.ob-cart__item');
    if (!li) { return; }
    var key = li.getAttribute('data-key');
    var line = (cart && cart.items.filter(function (i) { return i.key === key; })[0]) || null;
    if (!line) { return; }
    var next = rm ? 0 : line.quantity + parseInt(q.getAttribute('data-ob-qty'), 10);
    if (next < 0) { next = 0; }
    api('/cart/change.js', { id: key, quantity: next })
      .then(reconcile)
      .then(function (c) { cart = c; return loadCompareAt(c.items).then(function () { render(); }); });
  });

  elProtInput.addEventListener('change', function () {
    var want = elProtInput.checked;
    setDeclined(!want);
    var line = cart ? cart.items.filter(isProtection)[0] : null;
    if (want && !line) {
      /* THE SAME PROPERTIES UPCART SENDS, so the order line is identical to the one
         the store has been selling all along and anything reporting on
         __upcartShippingProtection keeps working. */
      api('/cart/add.js', {
        items: [{ id: CFG.protection.variantId, quantity: 1,
                  properties: CFG.protection.properties }]
      }).then(refresh);
    } else if (!want && line) {
      api('/cart/change.js', { id: line.key, quantity: 0 })
        .then(function (c) { cart = c; render(); });
    }
  });

  /* ------------------------------------------------------- add to cart, ajax
     THE GUARD OWNS THE SUBMIT, inline in the layout head, because this file is deferred
     and the button is clickable roughly a second before a deferred script runs. Anything
     bound here would miss every early click and the browser would submit natively. This
     only reacts to the result. */
  document.addEventListener('ob:cart:added', function (e) {
    if (!e.detail || !e.detail.ok) { return; }   /* a failed add changes nothing here */
    refresh();                                   /* keep the count and the drawer truthful */
    /* ADDING DOES NOT OPEN THE DRAWER. The popup is what the shopper sees. */
  });

  /* --------------------------------------------------------------- openers */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('.js-drawer-open-cart, [data-ob-cart-open], [data-ob-atc-viewcart]');
    if (!t) { return; }
    e.preventDefault();
    open(t);
  });

  document.addEventListener('cart:open', function () { open(null); });
  window.OBCart = { open: open, close: close, refresh: refresh };

  /* keep the drawer truthful if anything else changes the cart */
  document.addEventListener('cart:updated', refresh);

  /* =======================================================================
     THE /cart PAGE. Same helpers, same itemNode, same classes, so the page
     and the drawer cannot drift. Shopify renders the page server-side so it
     still works with JavaScript off; this only takes over live updating.

     PROTECTION IS NEVER IN THE ITEM LIST HERE. It is the tick-box row, and
     the list is filtered in Liquid AND again in pRender, so there is no path
     by which it becomes a line item with a stepper.
     ======================================================================= */
  var page = document.querySelector('[data-ob-cartpage]');
  if (page) {
    var pItems = page.querySelector('[data-ob-cartpage-items]');
    var pCount = page.querySelector('[data-ob-cart-count]');
    var pArrive = page.querySelector('[data-ob-cart-arrive]');
    var pArriveFoot = page.querySelector('[data-ob-cart-arrive-foot]');
    var pSub = page.querySelector('[data-ob-cart-subtotal]');
    var pTotal = page.querySelector('[data-ob-cart-total]');
    var pProt = page.querySelector('[data-ob-cart-prot-input]');

    var pPaintDates = function () {
      if (!window.OB || !OB.deliveryRange) { return; }
      var range = OB.deliveryRange(CFG.deliveryMin, CFG.deliveryMax);
      if (!range) { return; }
      if (pArrive) { pArrive.textContent = 'Arrives ' + range; }
      if (pArriveFoot) { pArriveFoot.textContent = 'Arrives ' + range; }
    };

    var pRender = function (c) {
      if (!c || !c.items) { return; }
      cart = c;
      /* the page renders its first paint from Liquid, so this only matters for
         re-renders after a mutation - the cache is primed by then */
      var lines = c.items.filter(function (i) { return !isProtection(i); });
      /* ONLY ON THE NON-EMPTY LAYOUT. The heading renders on both, so without the
         pItems guard an empty cart read "Cart - 0 items" instead of just "Cart". */
      if (pCount && pItems) {
        pCount.textContent = countText(
          lines.reduce(function (a, i) { return a + i.quantity; }, 0));
      }
      if (pItems) {
        pItems.textContent = '';
        lines.forEach(function (i) { pItems.appendChild(itemNode(i)); });
      }
      if (pSub) { pSub.textContent = money(c.items_subtotal_price); }
      if (pTotal) { pTotal.textContent = money(c.total_price); }
      if (pProt) { pProt.checked = !!c.items.filter(isProtection)[0]; }
      pPaintDates();
      /* AN EMPTY CART reloads once, so the page swaps to the server-rendered empty state
         rather than this file reproducing it in a second place.
         THE pItems GUARD IS WHAT STOPS IT LOOPING: the empty layout renders no item list
         at all, so without it `lines.length === 0` would be true on every load and the
         page would reload itself forever. */
      if (pItems && !lines.length) { window.location.reload(); }
    };

    pPaintDates();

    page.addEventListener('click', function (e) {
      var q = e.target.closest('[data-ob-qty]');
      var rm = e.target.closest('[data-ob-remove]');
      if (!q && !rm) { return; }
      e.preventDefault();
      var li = e.target.closest('.ob-cart__item');
      if (!li) { return; }
      var key = li.getAttribute('data-key');
      var line = (cart && cart.items.filter(function (i) { return i.key === key; })[0]) || null;
      var shown = li.querySelector('.ob-cart__qty-num');
      var current = line ? line.quantity : (parseInt(shown && shown.textContent, 10) || 1);
      var next = rm ? 0 : current + parseInt(q.getAttribute('data-ob-qty'), 10);
      if (next < 0) { next = 0; }
      api('/cart/change.js', { id: key, quantity: next })
        .then(reconcile)
        .then(function (c) { return loadCompareAt(c.items).then(function () { pRender(c); }); });
    });

    if (pProt) {
      pProt.addEventListener('change', function () {
        var want = pProt.checked;
        setDeclined(!want);
        fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
          .then(function (r) { return r.json(); })
          .then(function (c) {
            var line = c.items.filter(isProtection)[0];
            if (want && !line) {
              return api('/cart/add.js', {
                items: [{ id: CFG.protection.variantId, quantity: 1,
                          properties: CFG.protection.properties }]
              }).then(function () {
                return fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
                  .then(function (r) { return r.json(); });
              });
            }
            if (!want && line) { return api('/cart/change.js', { id: line.key, quantity: 0 }); }
            return c;
          })
          .then(pRender);
      });
    }

    /* PRIME AND PAINT ON LOAD. Without this the heading kept the server-rendered "Cart"
       until a mutation happened, so it never showed "Cart - N items" on arrival. This also
       gives the first stepper click real line data to work from. */
    getCart()
      .then(reconcile)
      .then(function (c) { return loadCompareAt(c.items).then(function () { pRender(c); }); });
  }
}());
